import { f as fragmentDefaultEntryName } from "../common/consts.js";
import { u as useFragmentEntry } from "./entry.js";
function useFragment(options) {
  const { injector } = options;
  const entries = /* @__PURE__ */ new Map();
  return {
    createEntry,
    createComponent
  };
  function createComponent(createOptions) {
    return createEntry(createOptions.entryName).createComponent(createOptions.componentName);
  }
  function createEntry(entryName = fragmentDefaultEntryName) {
    if (!entries.has(entryName)) {
      const entryInjector = injector.__internal.fork();
      const { id: fragmentId, fragmentName } = entryInjector.__internal.inject("fragmentInfo");
      const id = `${fragmentId}:${entryName}`;
      entryInjector.__internal.provide("entryInfo", { id, fragmentName, entryName });
      const entry = useFragmentEntry({
        federationLocalization: options.federationLocalization,
        networkService: options.networkService,
        injector: entryInjector,
        processException
      });
      entries.set(entryName, entry);
    }
    return entries.get(entryName);
  }
  function processException(...params) {
    const [error, info] = params;
    options.processException(error, {
      ...info,
      url: options.networkService.url,
      fragmentName: options.networkService.getName(),
      fragmentVersion: options.networkService.getVersion()
    });
  }
}
export {
  useFragment as u
};
//# sourceMappingURL=fragment.js.map
